module.exports = __webpack_public_path__ + "img/386195940.825d4196.png";